import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'
function Calendar({
  color = 'icon.arrowBlue',
  fill = 'transparent',
  ...props
}) {
  return (
    <IconBase viewBox='0 0 17 17' {...props}>
      <Path
        d='M11.408 1V4.20175'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M5.00569 1V4.20175'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M1 6.60334H15.4079'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.807 2.60156H2.60087C1.71639 2.60156 1 3.31795 1 4.20244V14.6081C1 15.4926 1.71639
                16.209 2.60087 16.209H13.807C14.6915 16.209 15.4079 15.4926 15.4079 14.6081V4.20244C15.4079
                3.31795 14.6915 2.60156 13.807 2.60156Z'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M4.21583 9.59073C4.10537 9.59073 4.01572 9.68038 4.01652 9.79084C4.01652 9.9013 4.10617 9.99095
                4.21663 9.99095C4.32709 9.99095 4.41674 9.9013 4.41674 9.79084C4.41674 9.68038 4.32709 9.59073
                4.21583 9.59073'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M8.21583 9.59073C8.10537 9.59073 8.01572 9.68038 8.01652 9.79084C8.01652 9.9013 8.10617 9.99095
                8.21663 9.99095C8.32709 9.99095 8.41674 9.9013 8.41674 9.79084C8.41674 9.68038 8.32709 9.59073
                8.21583 9.59073'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M12.2197 9.59073C12.1093 9.59073 12.0196 9.68038 12.0204 9.79084C12.0204 9.9013 12.1101 9.99095
                12.2205 9.99095C12.331 9.99095 12.4206 9.9013 12.4206 9.79084C12.4206 9.68038 12.331 9.59073 12.2197
                9.59073'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M4.21583 12.786C4.10537 12.786 4.01572 12.8757 4.01652 12.9862C4.01652 13.0966 4.10617
                13.1863 4.21663 13.1863C4.32709 13.1863 4.41674 13.0966 4.41674 12.9862C4.41674 12.8757
                4.32709 12.786 4.21583 12.786'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M8.21583 12.786C8.10537 12.786 8.01572 12.8757 8.01652 12.9862C8.01652 13.0966 8.10617
                13.1863 8.21663 13.1863C8.32709 13.1863 8.41674 13.0966 8.41674 12.9862C8.41674 12.8757
                8.32709 12.786 8.21583 12.786'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}
Calendar.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default Calendar
